import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowUpRight, Check } from 'lucide-react';
import { clubImage, clubImage2 } from '../mock';
import { Reveal } from '../components/Reveal';

const benefits = [
  'Invitation-only monthly gatherings with sector leaders',
  'Off-the-record dialogues on policy and markets',
  'Priority access to Enersider summits worldwide',
  'A curated network of change-makers and decision-takers',
  'Early briefings on the stories shaping the transition',
  'Members-only research notes and data drops',
];

export default function Club() {
  return (
    <div>
      <section className="relative min-h-[70vh] flex items-end">
        <img src={clubImage} alt="Club" className="absolute inset-0 w-full h-full object-cover" />
        <div className="absolute inset-0 bg-gradient-to-t from-[#111111] via-[#111111]/50 to-[#111111]/30" />
        <div className="relative section-pad pb-16 pt-40 text-[#ffffff] w-full">
          <div className="max-w-[1500px] mx-auto">
            <p className="eyebrow text-[#D01919] mb-4">One Enersider Club</p>
            <h1 className="font-display text-5xl md:text-8xl leading-[0.95] max-w-4xl">The most valuable room in energy.</h1>
          </div>
        </div>
      </section>

      <section className="section-pad py-24">
        <div className="max-w-[1500px] mx-auto grid lg:grid-cols-2 gap-16 items-start">
          <Reveal>
            <div>
              <h2 className="font-display text-4xl md:text-5xl leading-tight">More than a network. A vantage point.</h2>
              <p className="text-[#666666] text-lg mt-6">
                The One Enersider Club brings together a small, deliberate group of leaders shaping the energy transition — across renewables, gas, grids, storage and policy. Membership is by invitation, and every gathering is built around candid conversation you will not find on a public stage.
              </p>
              <div className="mt-8 rounded-2xl overflow-hidden aspect-[16/10]">
                <img src={clubImage2} alt="Members networking" className="w-full h-full object-cover" />
              </div>
            </div>
          </Reveal>
          <Reveal delay={120}>
            <div className="bg-[#111111] text-[#ffffff] rounded-3xl p-10">
              <p className="eyebrow text-[#D01919] mb-6">Membership includes</p>
              <ul className="space-y-4">
                {benefits.map((b, i) => (
                  <li key={i} className="flex items-start gap-3">
                    <span className="mt-0.5 w-6 h-6 rounded-full bg-[#D01919] text-white flex items-center justify-center shrink-0">
                      <Check size={14} strokeWidth={3} />
                    </span>
                    <span className="text-white/90">{b}</span>
                  </li>
                ))}
              </ul>
              <Link to="/contact" className="inline-flex items-center gap-1.5 mt-10 bg-[#D01919] text-white font-semibold px-6 py-3.5 rounded-full hover:bg-white transition-colors">
                Request an invitation <ArrowUpRight size={18} />
              </Link>
            </div>
          </Reveal>
        </div>
      </section>
    </div>
  );
}
